import React from "react";
import WechatQRCode from "../../assets/WeChatSupport.png";
import { SUPPORT_TOOLTIP_TITLE } from "../../constants/Constants";
import { Tooltip } from "@mui/material";
import IconButton from "../utils/IconButton";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";

const SupportMe = () => {
};

export default SupportMe;
